import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["mainDashboard", "list", "view", "3333", "4444", "5555", "6666", "7777", "8888", "9999"]

  connect() {
    this.controllerName = `operations--products--clinics--clients--helpers--dashboard`
    this.setAccountPermission()
  }

  doHelpersDashboard() {
    var html = `<div class="row" data-${this.controllerName}-target="mainDashboard">
                  <div class="col-6 pr-1" data-${this.controllerName}-target="list" data-controller="operations--products--clinics--managements--helpers--index"></div>
                  <div class="col-6 pl-1" data-${this.controllerName}-target="view" data-controller="operations--products--clinics--managements--helpers--save operations--products--clinics--managements--helpers--show"></div>
                </div>`

    var controller = this
    new Promise(function (resolve) {
      resolve(controller.getControllerByIdentifier(`operations--products--clinics--clients--show--main`).contentTarget.innerHTML = html)
    }).then(() => {
      controller.getControllerByIdentifier(`operations--products--clinics--clients--show--submenu`).dashboardToggleBtn(`ASSISTENTES`)

      controller.getControllerByIdentifier(`operations--products--clinics--managements--helpers--index`).permission = this.permission
      controller.getControllerByIdentifier(`operations--products--clinics--managements--helpers--show`).permission = this.permission
      controller.getControllerByIdentifier(`operations--products--clinics--managements--helpers--show`).info_permission = this.info_permission
      controller.getControllerByIdentifier(`operations--products--clinics--managements--helpers--show`).contact_permission = this.contact_permission
      controller.getControllerByIdentifier(`operations--products--clinics--managements--helpers--show`).profile_permission = this.profile_permission
      controller.getControllerByIdentifier(`operations--products--clinics--managements--helpers--save`).permission = this.permission

      controller.getControllerByIdentifier(`operations--products--clinics--managements--helpers--index`).doIndexListHtml()
      controller.getControllerByIdentifier(`operations--products--clinics--managements--helpers--show`).doViewHtml()
    })
  }

  setAccountPermission() {
    if (this.application.current_user.account_kind == `admin` || this.application.current_user.account_kind == `team`) {
      this.permission = `medclinic_client_helpers`
      this.info_permission = `medclinic_client_helper_infos`
      this.contact_permission = `medclinic_client_helper_contacts`
      this.profile_permission = `medclinic_client_helper_profiles`
    } else if (this.application.current_user.account_kind == `doctor`) {
      this.permission = `medclinic_doctor_client_helpers`
      this.info_permission = `medclinic_doctor_client_helper_infos`
      this.contact_permission = `medclinic_doctor_client_helper_contacts`
      this.profile_permission = `medclinic_doctor_client_helper_profiles`
    } else if (this.application.current_user.account_kind == `helper`) {
      this.permission = `medclinic_helper_client_helpers`
      this.info_permission = `medclinic_helper_client_helper_infos`
      this.contact_permission = `medclinic_helper_client_helper_contacts`
      this.profile_permission = `medclinic_helper_client_helper_profiles`
    }
  }

  getControllerByIdentifier(identifier) {
    return this.application.controllers.find(controller => {
      return controller.context.identifier === identifier;
    });
  }

  nameTarget(target) {
    return this.targets.find(target)
  }

  // new Promise(function (resolve) {
  //   resolve()
  // }).then(() => {
  // }) 

}
